import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=4678aa9b"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4678aa9b')) {
      api.createRecord('4678aa9b', component.options)
    } else {
      api.reload('4678aa9b', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=4678aa9b", function () {
      api.rerender('4678aa9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recuperacion/Form.vue"
export default component.exports